<template>
	<div class="preloader">
		<div class="text-center">
			<!-- <img v-if="loaderImage" :src="[loaderImage ? logos[loaderImage].default : logos['icmywealth'].default]" class="mw-100" height="100" alt="logo" /> -->
			<spinner-component class="mb-3" :loading="true" />

			<div>
				<!-- <div v-if="loaderImage" class="spinner-border spinner-border-sm text-primary" role="status">
					<span class="sr-only">Loading...</span>
				</div> -->
				<p class="h5 my-0 ml-1 d-inline">{{ loaderMessage || 'Please Wait...' }}</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},
	props: ['loaderImage', 'loaderMessage'],
};
</script>

<style scoped>
@keyframes hidePreloader {
	0% {
		width: 100%;
		height: 100%;
	}

	100% {
		width: 0;
		height: 0;
	}
}

body div.preloader {
	width: 100%;
	height: 70vh;
	z-index: 1071;
	opacity: 0;
	transition: opacity 0.5s ease;
	overflow: hidden;
	pointer-events: none;
	display: flex;
	align-items: center;
	justify-content: center;
}

body:not(.loaded) div.preloader {
	opacity: 1;
}
</style>
